module.exports = __webpack_public_path__ + "img/store-settlement-icon.ae4d64fd.svg";